var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_c('h3',{staticClass:"first"},[_vm._v(" "+_vm._s(_vm.$t(_vm.header))+" "),(_vm.edit)?_c('ExtraInfo',{attrs:{"id":_vm.header}}):_vm._e()],1),_c('span',{staticClass:"courseedit-sis-table data-clean"},[_c('div',{staticClass:"data-clean",domProps:{"innerHTML":_vm._s(_vm.translateTable(_vm.text))}}),_c('br')])])
}
var staticRenderFns = []

export { render, staticRenderFns }